// extracted by mini-css-extract-plugin
export default {"input":"BonusDialog_input__2Q6Oi","finePrint":"BonusDialog_finePrint__iFF-h"};